module.exports = __webpack_public_path__ + "static/media/share.ed6d85ab.svg";